const productData = [
    {
        id: 1,
        Title: "Galaxy Tab S6 Lite 10.4-inch Android Tablet 128GB",
        Cat: "Tablets",
        Price: "537,000",
        Img: "./Assets/notebook.png",
    },
    {
        id: 2,
        Title: "Airpod Pro",
        Cat: "Airpods",
        Price: "150,400",
        Img: "./Assets/airpod-pro.png",
    },
    {
        id: 3,
        Title: "Airpod 2",
        Cat: "Airpods",
        Price: "112,070",
        Img: "./Assets/airpod2.jpeg",
    },
    {
        id: 4,
        Title: "Airpod Max",
        Cat: "Headsets",
        Price: "707,000",
        Img: "./Assets/airpodmax.jpg",
    },
    {
        id: 5,
        Title: "Casio G-Shock M-4350",
        Cat: "Wristwatches",
        Price: "237,000",
        Img: "./Assets/gshock2.png",
    },
    {
        id: 6,
        Title: "Green Gucci Suede Purse",
        Cat: "Bags",
        Price: "150,000",
        Img: "./Assets/gucci-purse.png",
    },
    {
        id: 7,
        Title: "Lattafa Hayaati Perfume",
        Cat: "Perfumes",
        Price: "27,000",
        Img: "./Assets/hyatti.png",
    },
    {
        id: 8,
        Title: "Apple Iphone 12 256GB",
        Cat: "Mobile Phones",
        Price: "620,000",
        Img: "./Assets/iphone12.jpg",
    },
    {
        id: 9,
        Title: "Oculus Quest 2",
        Cat: "Headsets",
        Price: "402,000",
        Img: "./Assets/oculus2.png",
    },
    {
        id: 10,
        Title: "Audemars Piguet Royal Oak",
        Cat: "Wristwatches",
        Price: "350,120,000",
        Img: "./Assets/piguet-oak.png",
    },
    {
        id: 11,
        Title: "Apple Iphone 12 Pro Max 512GB",
        Cat: "Mobile Phones",
        Price: "879,000",
        Img: "./Assets/pro-max.png",
    },
    {
        id: 12,
        Title: "Richard Mille RM 66 Flying Tourbillon Red",
        Cat: "Wristwatches",
        Price: "514,000,000",
        Img: "./Assets/redmille.png",
    },
    {
        id: 13,
        Title: "Richard Mille RM 002-V2 Tourbillon Black",
        Cat: "Wristwatches",
        Price: "610,000,000",
        Img: "./Assets/richardmille.png",
    },
    {
        id: 14,
        Title: "Rolex Datejust 41",
        Cat: "Wristwatches",
        Price: "79,000,065",
        Img: "./Assets/rolex-datejust.jpg",
    },
    {
        id: 15,
        Title: "Samsung S23 Ultra 512GB",
        Cat: "Mobile Phones",
        Price: "820,000",
        Img: "./Assets/s23Ultra.jpg",
    },
    {
        id: 16,
        Title: "Hermes Izmar Slippers (Brown)",
        Cat: "Footwears",
        Price: "84,000",
        Img: "./Assets/hermes.webp",
    },
];

export default productData